<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar celular" : "Nuevo celular" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>
              {{ editing ? "Datos del celular" : "Datos del nuevo celular" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="phone_number">Número de celular *</label>
                    <input id="phone_number" type="text" v-model="form.phone_number" autocomplete="off"
                      placeholder="Ingresar número de celular" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.phone_number.$error,
                      }" />
                      <FormError v-if="$v.form.phone_number.$error && !$v.form.phone_number.required"
                      message="Número de celular es requerido" />
                    <FormError v-if="$v.form.phone_number.$error && !$v.form.phone_number.numeric"
                      message="Número de celular debe ser un valor numérico" />
                    <FormError message="Ingresa un número válido (entre 7 y 15 dígitos)"
                      v-if="$v.form.phone_number.$error && (!$v.form.phone_number.minLength || !$v.form.phone_number.maxLength)"></FormError>
                  </div>

                  <div class="form-group mb-0">
                    <label for="reason">Razón o motivo *</label>
                    <input id="reason" type="text" v-model="form.reason" autocomplete="off"
                      placeholder="Ingresar nombres" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.reason.$error,
                      }" />
                    <FormError v-if="$v.form.reason.$error && !$v.form.reason.required"
                      message="Razón o motivo es requerido" />
                  </div>
                </div>
              </div>

              <div class="form-group-buttons text-right">
                <router-link :to="{ name: 'travelbot-black-list' }" class="button button-light">
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">
                  Guardar
                </button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError } from "wize-admin";

import { BlackListService } from "@/core/services";
import { required, numeric, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  components: {
    FormError
  },
  data() {
    return {
      form: {
        phone_number: null,
        reason: null
      },
      editing: false,
    };
  },
  validations: {
    form: {
      phone_number: { required, numeric, minLength: minLength(7), maxLength: maxLength(15) },
      reason: { required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  computed: {},
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          ...this.form,
        };

        if (!this.editing) await BlackListService.save(data);
        else await BlackListService.update(this.$route.params.id, data);
        Alert.success("Se almacenó la información correctamente");
        if (this.editing) {
          this.load(this.$route.params.id);
        } else {
          this.$router.push({ name: "travelbot-black-list" }).catch(() => {});
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await BlackListService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "travelbot-black-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
